import React, { memo } from "react";
import SettingCardSkeleton from "./SettingCardSkeleton";

const OtherPreferencesSkeleton = memo(() => {
  return (
    <div className="grid grid-cols-1 gap-5 lg:gap-7.5 mb-[20px]">
      <SettingCardSkeleton
        titleWidth={150}
        controls={["switch", "switch", "switch", "switch"]}
        showFooter
      />
    </div>
  );
});

OtherPreferencesSkeleton.displayName = "OtherPreferencesSkeleton";

export default OtherPreferencesSkeleton;
